import { OrderApiClient } from '@fourthwall/services/dist/OrderApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useCalculateCancelRefundsQuery = createQueryHook(
  OrderApiClient.calculateCancelRefunds,
  {
    queryKey: ['calculateCancelRefunds'],
  },
)
